import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MultitenantService {

  public user: any = null;

  constructor(private httpClient: HttpClient, private router: Router, private toastr: ToastrService) {

  }
  //api url
  private apiUrl = environment.apiUrl;
  getTenantlist(page: number, pageSize: number): Observable<any> {
    return this.httpClient.post(`${this.apiUrl}/Tanent/GetAllTenantsLists`, { page, pageSize }).pipe(

    );
  }


  getTenantById(tenantId: number): Observable<any> {
    return this.httpClient.get(`${this.apiUrl}/Tanent/GetTenantById?id=${tenantId}`).pipe(

    );
  }
  activateTenant(model: any): Observable<any> {
    return this.httpClient.post(`${this.apiUrl}/Tanent/ActivateTenant`, model).pipe(

    );;
  }


  // Handle Errors

}
